
import { defineComponent, getCurrentInstance } from 'vue'

export default defineComponent({
  name: 'NavigationMenuHeaderEnvironment',
  props: {
    collapsed: Boolean,
  },
  setup() {
    const {
      proxy: { $epb },
    } = getCurrentInstance()

    const baseClass = 'epb-navigation-menu-header-environment'

    const classes = [baseClass, `${baseClass}--${$epb.environment.toLowerCase()}`]

    return {
      baseClass,
      classes,
    }
  },
})
